import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import ForgotPasswordPage from 'components/Landing/ForgotPasswordPage/ForgotPasswordPage';

import { registerComponents } from '../src/registrations';

registerComponents({ ForgotPasswordPage });
